















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class LoadingIndicator extends Vue {
  @Prop(Boolean) readonly loading!: boolean
}
